import { Pie } from "@ant-design/plots";
import React, { forwardRef, useMemo } from "react";
import { chartsColors } from "./colorConfig";
import CommonEmpty from "./commonEmpty";
// 饼图
const PieDom = forwardRef((props, ref) => {
  const { dataList, proportionVal } = props;
  const PieDomFn = useMemo(() => {
    const config = {
      appendPadding: [10, 40, 0, 60],
      data: dataList,
      colorField: "name",
      color: chartsColors,
      angleField: "summaryValue",
      radius: 0.75,
      legend: false,
      tooltip: {
        fields: ["name", "proportion"],
        formatter: (data) => {
          // console.
          return { name: data.name, value: data.proportion + "%" };
        },
      },
      label: {
        type: "outer",
        labelHeight: 28,
        offset: 20,
        layout: "pie-outer",
        formatter(text, list) {
          console.log(proportionVal);
          console.log("text", text);
          if (text.name.length > 5) {
            text.name = text.name.substring(0, 5) + "...";
          }
          // 字符太长添加省略号
          return (
            text.name +
            "\n" +
            (proportionVal == 1
              ? text.summaryValueHalfUp
              : text.proportion + "%")
          );
        },
      },

      interactions: [
        {
          type: "element-selected",
        },
        {
          type: "element-active",
        },
      ],
    };
    if (dataList?.length > 0) {
      return <Pie height={300} {...config} />;
    } else {
      return <CommonEmpty />;
    }
  }, [dataList]);
  return PieDomFn;
});

export default PieDom;
